import React from 'react';
import { SxStyle } from '../../../../types';
import MobileDevice from '../../../common/mobile-device';
import moment from 'moment';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Image from '../../../../components/common/image';

const styles: SxStyle = {
  container: {
    marginLeft: '8px',
    marginRight: '8px',
    maxHeight: '100%',
    overflow: 'hidden',
  },
  innerContainer: {
    position: 'absolute',
    top: '80px',
    width: 'calc(100% - 16px)',
    display: 'flex',
    alignItems: 'center',
  },
  box: {
    position: 'relative',
    backgroundColor: 'white',
    minHeight: '100px',
    width: '260px',
    borderRadius: 2,
    marginTop: '50px',
    padding: '12px',
  },
  logo: {
    height: '20px',
    width: '20px',
  },
  image: {
    height: '40px',
    width: '40px',
    objectFit: 'contain',
  },
};

interface Props {
  abbrv: string;
  name: string;
  title?: string;
  message?: string;
  date?: string;
  image?: string;
  logo?: string;
}

const PreviewPushDevice = ({ title, message, date, abbrv, name, image, logo }: Props) => {
  const dateToDisplay = moment(date).format('dddd, MMMM D');
  const timeToDisplay = moment(date).format('HH:mm');

  return (
    <MobileDevice device="mobile" displayDevice height={'600px'}>
      <Box sx={styles.container}>
        <Image alt="Phone background" src="/phone_background.png" />
        <Stack sx={styles.innerContainer}>
          <Typography color="white" fontSize={45}>
            {timeToDisplay}
          </Typography>
          <Typography color="white">{dateToDisplay}</Typography>
          <Box sx={styles.box}>
            <Stack spacing={1}>
              <Stack alignItems="center" direction="row" spacing={2}>
                <Image sx={styles.logo} src={logo} />
                <Typography fontSize={10} variant="caption">
                  {name}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={2}>
                <Stack spacing={1} flex={1}>
                  <Typography fontSize={12} variant="bold">
                    {title}
                  </Typography>
                  <Typography fontSize={12} variant="caption">
                    {message}
                  </Typography>
                </Stack>
                {image && <Image src={image} sx={styles.image} />}
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </MobileDevice>
  );
};

export default PreviewPushDevice;
